import React from "react";

import { useIsMobile } from "hooks";

import { DesktopSideBar } from "./DesktopSideBar";
import { MobileSideBar } from "./MobileSideBar";

interface ResponsiveSideBarProps {
  ContentElement: React.ElementType;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAfterCloseSidebar: () => void;
  isBrandingVisible?: boolean;
  isHashModalOpen?: boolean;
}

export const ResponsiveSideBar = React.memo(
  ({
    ContentElement,
    isOpen,
    setIsOpen,
    isBrandingVisible = true,
    onAfterCloseSidebar,
    isHashModalOpen = false,
  }: ResponsiveSideBarProps) => {
    const isMobile = useIsMobile();

    if (isMobile) {
      return (
        <MobileSideBar
          ContentElement={ContentElement}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isBrandingVisible={isBrandingVisible}
          onAfterCloseSidebar={onAfterCloseSidebar}
        />
      );
    } else {
      return (
        <DesktopSideBar
          ContentElement={ContentElement}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isBrandingVisible={isBrandingVisible}
          onAfterCloseSidebar={onAfterCloseSidebar}
          isHashModalOpen={isHashModalOpen}
        />
      );
    }
  },
);
